import { Fields } from '@hako/core'
import { HatchOffers } from '@/pages/products/components/buy-section/HatchOffers'
import { useHatch } from '@/modules/hatch/hooks/useHatch'

export const BuySection = () => {
    const { offers, isLoading } = useHatch()

    if (offers.length === 0 && !isLoading) {
        return null
    }

    return (
        <section id="buy" className="section buy u-padding-bottom-xxlarge">
            <div className="container container--boxed">
                <Fields.Text
                    as="h2"
                    className="h2 u-margin-bottom-medium"
                    slug="product-hatch-widget-header"
                >
                    Available to buy
                </Fields.Text>
                <HatchOffers />
            </div>
        </section>
    )
}
